import { QueryBuilderSelector } from './QueryBuilderSelector';
import { useEffect, useState } from 'react';
import { LIMITS } from './DataPanelConstants';
import { Input } from '@appd/uik';

interface QueryBuilderLimitSelectorProps {
  value: string;
  onChange: (e: string) => void;
}

export const QueryBuilderLimitSelector = ({ value, onChange }: QueryBuilderLimitSelectorProps) => {
  const valueArr = value.split('.');
  const [limitOption, setLimitOption] = useState<LIMITS>((valueArr[0] as LIMITS) ?? LIMITS.METRICS);
  const [limitDef, setLimitDef] = useState<string>(valueArr[1] ?? '');

  useEffect(() => {
    onChange([limitOption, limitDef].join('.'));
  }, [limitOption, limitDef]);

  return (
    <div className="flex grow flex-row divide-x rounded-md border-2 mt-2 py-2">
      <div className="text-base w-[75px] text-center">Limit</div>
      <div className="min-w-[150px] pl-2 flex flex-row">
        <div>
          <div className="text-sm leading-5">Limit Type</div>
          <div className="flex selector-container">
            <div className="w-[150px]">
              <QueryBuilderSelector
                value={limitOption}
                placeHolder="Select Limit Type"
                options={[LIMITS.METRICS, LIMITS.TOPOLOGY]}
                onChange={e => setLimitOption(e)}
              ></QueryBuilderSelector>
            </div>
          </div>
        </div>
        <div className="pr-2">
          <div className="text-sm leading-5">Definition</div>
          <div className="text-base w-[300px]">
            <Input
              className="px-2 border-2 rounded-md truncate"
              style={{}}
              onChange={e => {
                setLimitDef(e.target.value);
              }}
              placeholder={'Enter Definition'}
              value={limitDef}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
